var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-products-exlusive-units"},[_c('ui-card-exclusive-units'),(_vm.getHasSummary)?_c('ui-summary'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }